import { createContext } from 'react';

const WidgetAPIContext = createContext({});

export default WidgetAPIContext;



// WEBPACK FOOTER //
// ./src/javascripts/app/widgets/WidgetApi/WidgetApiContext.es6.js